import * as core from '../../../../../../../core'

import { query } from './overview-report-card.query'

export const RESOURCE = {
  payload: {
    alias: 'overview.report.card',
    description: 'Overview report card for change impacts',
    name: 'Overview Report Card',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
